import React from 'react';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

export default function ConfirmationDialog(props: any) {
  function renderFooter() {
    return (
      <div>
        <Button
          label="Não"
          type="button"
          icon="pi pi-times"
          onClick={() => props.reject()}
          className="p-button-text"
        />
        <Button
          type="button"
          label="Sim"
          icon="pi pi-check"
          onClick={() => props.accept()}
        />
      </div>
    );
  }

  return (
    <Dialog
      header="Confirmação"
      visible={props.visible}
      modal
      baseZIndex={6000}
      closable={false}
      draggable={false}
      style={{width: '350px'}}
      footer={renderFooter()}
      onHide={() => props.reject()}
    >
      <div className="d-flex justify-content-between align-content-center ">
        <span>{props.text ? props.text : 'Confirma essa operação?'}</span>
      </div>
    </Dialog>
  );
}
